/**
 * La forma canónica de un teléfono: el E.164 que decide `libphonenumber-js`.
 *
 * POR QUÉ EXISTE. El servidor (`supabase/functions/_shared/phone.ts`) normaliza
 * cada número con libphonenumber antes de enviar, validar y vincular, y responde
 * con ESA forma. La app comparaba contra "+" y los dígitos tal como se
 * escribieron, que casi siempre coincide, pero no siempre: un número de EE. UU.
 * o Canadá escrito con su prefijo troncal ("+1 1 201 555 0123") es un número
 * real y enviable, y el servidor lo devuelve como "+12015550123". El vínculo
 * quedaba hecho y la app decía que no (TAGO-MOBILE-53).
 *
 * Misma biblioteca y mismo subconjunto `/max` que el servidor, así que las dos
 * mitades no pueden discrepar sobre cuál es el número. Un valor que no es un
 * número válido devuelve null: quien compara tiene que tratarlo como "no
 * confirmado", nunca como igual a otro null.
 */
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

export function canonicalPhone(value: string | null | undefined): string | null {
  // GoTrue guarda el teléfono sin '+', y la gente lo escribe con espacios,
  // guiones o paréntesis. Los dígitos son lo único que significa algo.
  const digits = typeof value === 'string' ? value.replace(/\D/g, '') : ''
  if (!digits) return null
  try {
    const parsed = parsePhoneNumberFromString(`+${digits}`)
    return parsed?.isValid() ? parsed.number : null
  } catch {
    return null
  }
}
